import { FileActionEnum, MimeTypesEnum } from 'src/app/utils/enums';
import { environment } from 'src/environments/environment';
import { AccountService } from '../../auth/account.service';
import { BlobToPdfService } from '../../blob-to-pdf.service';
import { FileConvertorService } from '../file-convertor-service';
import { ConversionOptions } from '../models/conversion-options';
import { ConvertorParams } from '../models/convertor-params';
import { ImageToPdfConversionParams } from '../models/image-to-ddf-conversion-params';
import { BaseConversion } from './base-conversion';

export class ImageToPdfConversion extends BaseConversion {
    protected file: File | null;
    protected url: string = environment.conversions.imgPdfUrl;
    protected action: FileActionEnum = FileActionEnum.ConvertImage;
    protected type: MimeTypesEnum = MimeTypesEnum.ApplicationPdf;
    protected params: ImageToPdfConversionParams = {
        langCode: 'nl',
        outputFormat: 'PDF'
    };

    constructor(readonly services: [FileConvertorService, AccountService, BlobToPdfService]) {
        super(...services);
    }

    prepareConversionParams(): ConvertorParams | null {
        if (this.file === null) {
            return null;
        }

        const formData = new FormData();
        formData.append('file', this.file, this.file.name);

        return {
            action: this.action,
            type: this.type,
            formData,
            url: this.url,
            params: this.params,
            fileName: this.file.name,
            paneIndex: (this.paneIndex !== null ? this.paneIndex : null),
            metadata: this.metadata
        };
    }

    async setOptions(options: ConversionOptions): Promise<void> {
        options = options || {};
        this.file = options.file || null;
        this.paneIndex = (options.paneIndex !== null ? options.paneIndex as number : null);
        this.metadata = (options.metadata ? options.metadata : null);
    }
}
